module.exports = __webpack_public_path__ + "img/y_2021.417658d2.png";